import { useParams } from "react-router-dom";
import { useMutation } from "react-query";
import { axios } from "../lib/request";

export const useDonationPayMutation = () => {
    const { game_id } = useParams();
    const { isLoading, mutateAsync, error, data } = useMutation(
        (params) =>
            axios.patch(
                `${process.env.REACT_APP_API_DONATE_URL}/${game_id}/donations.json`,
                params
            ),
        {
            onError: (error) => console.log("[error]", error),
        }
    );

    return { isPaying: isLoading, pay: mutateAsync, error, data };
};